import { useState } from "react"
import {
  subscriptionPlans,
  propertyLabels,
  periods,
  getDisplayPrice,
  getDiscountBadge,
  type PaymentTerm,
} from "../data/subscriptionPlans"

export function GoPricingSection() {
  const [selectedPeriod, setSelectedPeriod] = useState<PaymentTerm>("yearly")
  const plans = subscriptionPlans

  return (
    <div className="mk-section mk-section-alt" style={{ position: "relative" }}>
      {/* Bottom fade overlay (matches v1) */}
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: 100,
          pointerEvents: "none",
          background: "linear-gradient(to bottom, transparent, #fff)",
        }}
      />
      <div
        className="mk-container mk-text-center"
        style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <h2 className="mk-title">
          Pricing & Plans <span className="mk-title-accent">for To To-Do</span>
        </h2>
        <p className="mk-subtitle">
          Use To To-Do for free forever, or upgrade to unlock sync,
          collaboration, and AI-powered features.
        </p>

        {/* 30 days free info */}
        <div className="mk-pricing-info">
          <img src="/marketing/go/icons/rocket-pink.svg" alt="" style={{ width: 22, height: 22 }} />
          New users get 30 days of the Standard plan for free!
        </div>

        {/* Period toggle */}
        <div className="mk-pricing-toggle">
          {periods.map((period) => (
            <button
              key={period.key}
              className={selectedPeriod === period.key ? "active" : ""}
              onClick={() => setSelectedPeriod(period.key)}
            >
              {period.discount ? (
                <span
                  className="mk-save-chip"
                  style={{
                    visibility: period.discount ? "visible" : "hidden",
                  }}
                >
                  {period.discount}
                </span>
              ) : (
                <span className="mk-save-chip" style={{ visibility: "hidden" }}>
                  Save 10%
                </span>
              )}
              {period.label}
            </button>
          ))}
        </div>

        {/* Pricing grid */}
        <div style={{ width: "100%", overflowX: "auto" }}>
          <div className="mk-pricing-grid">
            {/* Headers row */}
            <div /> {/* empty top-left cell */}
            {plans.map((plan) => (
              <div
                key={plan.id}
                className={`mk-pricing-header ${plan.id === "premium" ? "mk-plan-coming" : ""}`}
              >
                <div className="mk-plan-icon">
                  <img
                    src={
                      plan.id === "free"
                        ? "/marketing/go/icons/leaf-pink.svg"
                        : plan.id === "standard"
                        ? "/marketing/go/icons/rocket-pink.svg"
                        : "/marketing/go/icons/trophy-pink.svg"
                    }
                    alt=""
                  />
                </div>
                <h4>{plan.name}</h4>
                <p>{plan.description}</p>
                {plan.id === "premium" && (
                  <span className="mk-coming-chip">Coming soon</span>
                )}
              </div>
            ))}

            {/* Price row */}
            <div className="mk-pricing-label">Price</div>
            {plans.map((plan) => {
              const price = getDisplayPrice(plan, selectedPeriod)
              const badge =
                plan.pricing[selectedPeriod].price > 0
                  ? getDiscountBadge(selectedPeriod)
                  : null

              return (
                <div
                  key={plan.id + "-price"}
                  className={`mk-pricing-cell ${plan.id === "premium" ? "mk-plan-coming" : ""}`}
                >
                  <span style={{ fontWeight: 500, position: "relative" }}>
                    {price}
                    {badge && <span className="mk-price-badge">{badge}</span>}
                  </span>
                </div>
              )
            })}

            {/* Feature rows */}
            {Object.entries(propertyLabels).map(([key, label]) => (
              <>
                <div key={key + "-label"} className="mk-pricing-label">
                  {label}
                </div>
                {plans.map((plan) => (
                  <div
                    key={plan.id + "-" + key}
                    className={`mk-pricing-cell ${plan.id === "premium" ? "mk-plan-coming" : ""}`}
                  >
                    {String((plan as unknown as Record<string, unknown>)[key])}
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>

        <p className="mk-pricing-note">
          Buy on the{" "}
          <a href="https://totodo.app/today?setting=account">web</a> for the
          best price and to use promo codes. In-app prices are higher due to
          store fees.
        </p>
      </div>
    </div>
  )
}
